import { AnalysisType } from '@domain/constant/analysisType';

export enum AccStatusTypes {
  COMPLETE = 'complete', // 분석완료
  INCOMPLETE = 'incomplete', // 분석중
  ERROR = 'error', // 분석오류
}

export const accAnalysisStatusMap: Record<AnalysisType, AccStatusTypes> = {
  COMPLETE: AccStatusTypes.COMPLETE,
  PROGRESS: AccStatusTypes.INCOMPLETE,
  FAILED: AccStatusTypes.ERROR,
};
